import { render, staticRenderFns } from "./ntpAddress.vue?vue&type=template&id=2e508fa7&scoped=true"
import script from "./ntpAddress.vue?vue&type=script&lang=js"
export * from "./ntpAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e508fa7",
  null
  
)

export default component.exports